export const adminV4Icons = {
  adminDashboardIcon: "compass",
  membersIcon: "people-circle",
  contentIcon: "page",
  coursesIcon: "graduate-cap",
  marketingHubIcon: "paper-plane",
  workflowsIcon: "zap",
  aiAgentsIcon: "sparkle-box",
  aiInboxIcon: "inbox-ai",
  paywallsIcon: "money-hand",
  plansIcon: "calendar",
  analyticsIcon: "chart-square",
  affiliatesIcon: "affiliates",
  settingsIcon: "settings-gear",
  siteIcon: "window",
  developersIcon: "code-brackets",
  customizeThemeIcon: "color-swatch",
  viewAsIcon: "eye-open",
  inviteMemberIcon: "people-add",
  plusIcon: "tablet",
  moderationIcon: "shield-check",
} as const;
